"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objTitle = exports.defaultSpot = exports.defaultObj = exports.defaultArea = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var defaultObj = exports.defaultObj = {
  image: '',
  imagePage: '',
  fileUrl: '',
  sliderImages: [],
  sliderImage: '',
  merchantType: JSON.parse(_jsCookie.default.get('JavaMerInfo')).merchantType,
  merId: JSON.parse(_jsCookie.default.get('JavaMerInfo')).merId,
  name: '',
  cateId: 0,
  categoryId: 556,
  category: '',
  tags: [],
  admissionAddress: '',
  ticketType: 0,
  sort: 0,
  salesPrice: 0,
  price: 0,
  inventory: 1,
  applicablePeriod: [],
  agreement: '',
  refundType: '',
  withinXDays: 0,
  admissionStartTime: '',
  admissionEndTime: '',
  scenicId: 0,
  remark: '',
  canVerificationNum: 1,
  validateStartTime: '',
  validateEndTime: '',
  limitBuyRuleIds: [],
  productReturnRuleIds: [],
  ext: {
    returnKey: '',
    returnKeyValue: '',
    commissionKey: '',
    commissionValue: '',
    purchaseValue: '',
    limitBuyDesc: ''
  },
  childList: [{
    id: 0,
    ticketId: 0,
    childTicketId: 0,
    isUnlimited: 0,
    canVerificationNum: 0,
    dayVerificationNum: 0,
    monthVerificationNum: 0,
    createBy: '',
    createTime: '',
    delFlag: 0
  }]
};
var defaultArea = exports.defaultArea = {
  scenicName: '',
  address: '',
  image: '',
  adjust: '',
  officialPhone: '',
  sliderImages: [],
  imagePage: '',
  blurb: '',
  merchantType: JSON.parse(_jsCookie.default.get('JavaMerInfo')).merchantType,
  merId: JSON.parse(_jsCookie.default.get('JavaMerInfo')).merId,
  auditStatus: 4,
  isAudit: 'false'
};
var defaultSpot = exports.defaultSpot = {
  scenicAreaId: null,
  scenicName: '',
  address: '',
  location: [],
  spotPhone: '',
  admissionStartTime: '',
  admissionEndTime: '',
  image: '',
  imagePageList: [],
  // 改为数组，支持多图
  blurb: '',
  audioGuideUrl: '',
  tags: [],
  sort: null,
  delFlag: 0,
  remark: ''
};
var objTitle = exports.objTitle = {
  price: {
    title: '售价（元）'
  },
  vipPrice: {
    title: '会员价（元）'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  itemNumber: {
    title: '商品条码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  }
};